import React from "react";
import { Link } from "react-router-dom";

export const BrandLogo = ({ size = 44, withText = false, className = "" }) => (
  <Link to="/" className={`inline-flex items-center gap-2.5 ${className}`} data-testid="brand-logo">
    <img
      src="/brand/moments-made-logo.png"
      alt="Moments Made"
      width={size}
      height={size}
      className="rounded-full"
      style={{ boxShadow: "var(--shadow-card)" }}
    />
    {withText && (
      <span className="font-display text-lg font-semibold" style={{ color: "hsl(var(--brand-brown))" }}>
        Moments Made
      </span>
    )}
  </Link>
);
